// extracted by mini-css-extract-plugin
module.exports = {"timetableCourseCard":"l8XLjYR","delete":"UlRT79s","timetableCourseCardTitle":"HxSI_ET","timetableCourseCardLocation":"_0cXxEEl"};